export enum EHistoryQueryKey {
  HISTORY = 'HISTORY',
  HISTORY_USERS = 'HISTORY_USERS',
  HISTORY_CRUD = 'HISTORY_CRUD',
  HISTORY_LOGIN = 'HISTORY_LOGIN',
  HISTORY_DOCUMENT = 'HISTORY_DOCUMENT',
  HISTORY_DOCUMENTS = 'HISTORY_DOCUMENTS',
}
